var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibility),expression:"visibility"}],staticClass:"center",attrs:{"src":_vm.imgPath,"alt":"animation"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }